import moment from 'moment'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { fetchPurchaseOrders, getPurchaseOrders } from '../../app/reducers/PurchaseOrder/purchaseOrderSlice';
import { useDispatch, useSelector } from 'react-redux';
import PageWithCard from '../../components/infrastructure/PageWithCard';
import TableWithHeadingAndGlobalSearch from '../../components/Table/TableWithHeadingAndGlobalSearch';
import PaginationClassic from '../../components/infrastructure/pagination/PaginationClassic';
import numeral from 'numeral';
import PrimaryButton from '../../components/infrastructure/Buttons/PrimaryButton';
import PurchaseOrderStatusModal from './PurchaseOrderStatusModal';
import { authAxiosInstance } from '../../utils/axiosConfig';
import QueryString from 'qs';

function DeliveryExecutiveDashboard() {
    const [isStatusModalOpen, setIsStatusModalOpen] = useState(false);
    const [purchaseOrderStatusData, setPurchaseOrderStatusData] = useState({});
    const [page, setPage] = useState(1);
    const [purchaseOrder, setPurchaseOrder] = useState({
        docs: [],
    });

    const [loading, setLoading] = useState(false);

    const getPurchaseOrders = async () => {
        try {
            setLoading(true);

            const data = {
                status: 'dispatch',
                populate: true,
                page,
            };
            const string = QueryString.stringify(data);

            const resp = await authAxiosInstance.get(
                `/purchaseOrder?${string}`
            );
            if (!resp) return;
            console.log("resp.data", resp)
            setPurchaseOrder(resp?.data?.data);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };


    const columns = [
        {
            Header: 'SRNO',
            Cell: (prop) => {
                const { data, row } = prop;
                return row.index + purchaseOrder?.pagingCounter;
            },
        },
        {
            Header: 'Date',
            Cell: ({ row }) => {
                return (
                    <>
                        {row?.original?.createdAt ? (
                            <p className="flex items-center">
                                Op :-{' '}
                                {moment(row?.original?.createdAt).format(
                                    'DD/MM/YYYY HH:mm'
                                )}
                            </p>
                        ) : (
                            ''
                        )}
                        {row?.original?.inProgressDate ? (
                            <p>
                                Ip :-{' '}
                                {moment(row?.original?.inProgressDate).format(
                                    'DD/MM/YYYY HH:mm'
                                )}
                            </p>
                        ) : (
                            ''
                        )}

                        {row?.original?.dispatchDate ? (
                            <p>
                                Dp :-{' '}
                                {moment(row?.original?.dispatchDate).format(
                                    'DD/MM/YYYY HH:mm'
                                )}
                            </p>
                        ) : (
                            ''
                        )}

                        {row?.original?.deliveredDate ? (
                            <p>
                                Dv :-{' '}
                                {moment(row?.original?.deliveredDate).format(
                                    'DD/MM/YYYY HH:mm'
                                )}
                            </p>
                        ) : (
                            ''
                        )}

                        {row?.original?.canceledDate ? (
                            <p>
                                Cl :-
                                {moment(row?.original?.canceledDate).format(
                                    'DD/MM/YYYY HH:mm'
                                )}
                            </p>
                        ) : (
                            ''
                        )}
                        <div className="pt-4">
                            <PrimaryButton
                                className={`p-1 text-sm`}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setIsStatusModalOpen(true);
                                    setPurchaseOrderStatusData(row?.original);
                                }}
                                type="button"
                            >
                                Update Status
                            </PrimaryButton>
                        </div>
                    </>
                );
            },
        },
        {
            Header: 'ORD_Number',
            accessor: 'orderNumber',
        },
        // {
        //     Header: 'Customer',
        //     accessor: 'customer.name',
        // },
        // {
        //     Header: 'Customer',
        //     Cell: ({ row }) => {
        //         return (
        //             <div className="max-w-[150px] text-pretty ">
        //                 <p>{row.original?.customer?.name}</p>
        //                 <p><span className='font-semibold'>Location:</span>{row.original?.customer?.dispatchLocationData?.name}</p>
        //             </div>
        //         );
        //     },
        // },
        // {
        //     Header: 'Company',
        //     accessor: 'customer.companyData.name'
        // },
        {
            Header: 'Company',
            Cell: ({ row }) => {
                return (
                    <div className="max-w-[150px] text-pretty ">
                        <p>{row.original?.customer?.companyData?.name}</p>
                    </div>
                );
            },
        },
        // {
        //     Header: 'Product',
        //     accessor: 'product.name',
        // },
        {
            Header: 'Product',
            Cell: ({ row }) => {
                return (
                    <div className="max-w-[150px] text-pretty ">
                        <p>{row?.original?.product?.name}</p>
                    </div>
                );
            },
        },
        {
            Header: 'Color',
            Cell: ({ row }) => {
                return (
                    <div className="flex flex-col gap-2 ">
                        <ul className="space-y-2 text-sm text-gray-600">
                            <li className="flex justify-between  items-center">
                                <span className="font-medium">Cyan:</span>
                                <span>
                                    {numeral(row?.original?.cyan).format('0,0')}
                                </span>
                            </li>
                            <li className="flex justify-between items-center">
                                <span className="font-medium">Magenta:</span>
                                <span>
                                    {numeral(row?.original?.magenta).format(
                                        '0,0'
                                    )}
                                </span>
                            </li>
                            <li className="flex justify-between items-center">
                                <span className="font-medium">Black:</span>
                                <span>
                                    {numeral(row?.original?.black).format(
                                        '0,0'
                                    )}
                                </span>
                            </li>
                            <li className="flex justify-between items-center">
                                <span className="font-medium">Yellow:</span>
                                <span>
                                    {numeral(row?.original?.yellow).format(
                                        '0,0'
                                    )}
                                </span>
                            </li>
                            <li className="flex justify-between items-center">
                                <span className="font-medium">C.S:</span>
                                <span>
                                    {numeral(
                                        row?.original?.cleaningSolution
                                    ).format('0,0')}
                                </span>
                            </li>
                        </ul>
                    </div>
                );
            },
        },
        // {
        //     Header: 'Customer Msg.',
        //     Cell: ({ row }) => {
        //         return (
        //             <div className="max-w-[150px] text-pretty flex ">
        //                 <p>{row?.original?.customerMessage}</p>
        //             </div>
        //         );
        //     },
        // },
        // {
        //     Header: 'Dispatch Note',
        //     Cell: ({ row }) => {
        //         return (
        //             <div className="max-w-[150px] text-pretty flex ">
        //                 <p>{row?.original?.dispatchNote}</p>
        //             </div>
        //         );
        //     },
        // },
        // {
        //     Header: 'Action',
        //     Cell: (prop) => {
        //         const { data, row } = prop;
        //         return (
        //             <div className="flex items-center gap-2 cursor-pointer">
        //                 <PrimaryButton
        //                     onClick={(e) => {
        //                         e.stopPropagation();
        //                         setIsStatusModalOpen(true);
        //                         setPurchaseOrderStatusData(row?.original);
        //                     }}
        //                     type="button"
        //                 >
        //                     Update Status
        //                 </PrimaryButton>
        //             </div>
        //         );
        //     },
        // },
    ];
    const columnsMemo = useMemo(() => columns, [columns]);
    const dataMemo = useMemo(
        () => (purchaseOrder.docs ? purchaseOrder.docs : []),
        [purchaseOrder.docs]
    );


    useEffect(() => {
        getPurchaseOrders();
    }, [page]);

    const debouncedSearch = useCallback(
        _.debounce(async (search) => {
            try {
                setLoading(true);

                const data = {
                    populate: true,
                    search,
                    status: 'dispatch',
                    page,
                };
                const string = QueryString.stringify(data);

                const resp = await authAxiosInstance.get(
                    `/purchaseOrder?${string}`
                );
                if (!resp) return;
                setPurchaseOrder(resp?.data?.data);
            } catch (error) {
                console.error(error);
            } finally {
                setLoading(false);
            }
        }, 300),
        [page]
    );


    return (
        <>
            <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
                <div>
                    <h1 className="text-2xl md:text-3xl text-slate-800 font-bold">
                        Dashboard
                    </h1>
                    <p className="text-sm text-slate-500 mt-1">{moment().format('dddd, MMMM D, YYYY')}</p>
                </div>
            </div>
            <div className='p-4'>
                <PurchaseOrderStatusModal
                    isStatusModalOpen={isStatusModalOpen}
                    setIsStatusModalOpen={setIsStatusModalOpen}
                    purchaseOrderStatusData={purchaseOrderStatusData}
                    page={page}
                    currentStatus={'dispatch'}
                    onSuccess={async () => { getPurchaseOrders() }}
                />
                <TableWithHeadingAndGlobalSearch
                    heading={`View Purchase Order`}
                    loading={loading}
                    columns={columnsMemo}
                    data={dataMemo}
                    searchFunction={(value) => {
                        debouncedSearch(value);
                    }}
                />
                <PaginationClassic
                    paginationDetails={{
                        ...purchaseOrder,
                        docs: purchaseOrder.docs,
                    }}
                    setPage={setPage}
                />
            </div>

        </>
    )
}

export default DeliveryExecutiveDashboard